// for salary details of employee

export const RESER_EXPERIENCE_INFO = "resign_experience_info";
export const EXPERIENCE_INFO = "experience_info";
export const EXPERIENCE_INFO_SUCCESS = "experience_info_success";
export const EXPERIENCE_INFO_FAILURE = "experience_info_failure";
